import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid, Divider } from '@material-ui/core'
import SpecificComponent from '../../../commons/SpecificComponent';






export default class OpenEditFactura extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }


    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    style={{ zIndex: 6000 }}
                    maxWidth={'sm'}
                >
                    <DialogActions >
                    <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>


                    <DialogContent>
                        <Grid container>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>
                                    <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <span style={{ marginRight: 20, fontSize: 18, display: 'block', fontWeight: 600 }}>{this.dictionary.financiar.factura}</span>
                                    </Grid>

                                    <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <span style={{ marginRight: 20, fontSize: 14, display: 'block' }}>{this.props.factura.localitate}</span>
                                    </Grid>

                                </Grid>

                                <Divider style={{marginTop:20}} className="pm-divider" />
                            </Grid>


                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>
                                    <Grid style={{marginTop:20}} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div style={{ position: 'relative', textAlign: 'left' }}>
                                            <input
                                                style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                                id='document'
                                                type="text"
                                                step='any'
                                                className='add-project-input'
                                                placeholder={'Adauga seria si numarul facturii'}
                                                margin="normal"
                                                name='document'
                                                value={this.props.factura.document || ''}
                                                onChange={this.props.changeFactura}
                                            // onBlur={this.props.updateAngajatData}
                                            />
                                            <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.financiar.serieFactura}</label>
                                        </div>

                                    </Grid>

                                    <Grid style={{marginTop:20}} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div style={{ position: 'relative', textAlign: 'left' }}>
                                            <input
                                                style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                                id='valoare'
                                                type="number"
                                                step='any'
                                                className='add-project-input'
                                                placeholder={'Valoarea totala a facturii'}
                                                margin="normal"
                                                name='valoare'
                                                value={this.props.factura.valoare || ''}
                                                onChange={this.props.changeFactura}
                                            // onBlur={this.props.updateAngajatData}
                                            />
                                            <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.financiar.valoareLei}</label>
                                        </div>

                                    </Grid>

                                    <Grid style={{marginTop:20}} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div style={{ position: 'relative', textAlign: 'left' }}>
                                            <input
                                                style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                                id='data_emitere'
                                                type="date"
                                                step='any'
                                                className='add-project-input'
                                                placeholder={''}
                                                margin="normal"
                                                name='data_emitere'
                                                value={this.props.factura.data_emitere || ''}
                                                onChange={this.props.changeFactura}
                                            // onBlur={this.props.updateAngajatData}
                                            />
                                            <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.financiar.dataEmitere}</label>
                                        </div>

                                    </Grid>

                                    <Grid style={{marginTop:20}} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div style={{ position: 'relative', textAlign: 'left' }}>
                                            <input
                                                style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                                id='termen'
                                                type="date"
                                                step='any'
                                                className='add-project-input'
                                                placeholder={''}
                                                margin="normal"
                                                name='termen'
                                                value={this.props.factura.termen || ''}
                                                onChange={this.props.changeFactura}
                                            // onBlur={this.props.updateAngajatData}
                                            />
                                            <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.financiar.dataScadenta}</label>
                                        </div>

                                    </Grid>

                                    <Grid style={{marginTop:20}} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div style={{ position: 'relative', textAlign: 'left' }}>
                                            <input
                                                style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                                id='data_ultimei_incasari'
                                                type="date"
                                                step='any'
                                                className='add-project-input'
                                                placeholder={''}
                                                margin="normal"
                                                name='data_ultimei_incasari'
                                                value={this.props.factura.data_ultimei_incasari || ''}
                                                onChange={this.props.changeFactura}
                                            // onBlur={this.props.updateAngajatData}
                                            />
                                            <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.financiar.dataIncasarii}</label>
                                        </div>

                                    </Grid>

                                    <Grid style={{marginTop:20}} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Button
                                            style={{ marginRight: 20 }}

                                            className={'add-button-green'} onClick={() => { this.props.salveazaFactura() }}  >

                                            <i style={{
                                                fontSize: 14,
                                                marginRight: 10
                                            }} className='material-icons'>add</i>  {this.dictionary.financiar.salveaza}
                                        </Button>

                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                    </DialogContent>

                    {/* <h2 className='pm-dialog-alert-title'>{this.props.title}</h2> */}
                    {/* <DialogActions className="pm-dialog-bottom-buttons">




                    </DialogActions> */}


                </Dialog>
            </div>
        );
    }
}